// removed by extract-text-webpack-plugin
module.exports = {"container":"_2J9o1Sfn","login-container":"wfT6ZEcx","title-container":"_3wZEN2MV","login-form":"XZBoerXQ","input-info":"EYXFhArh","submit":"_1-94nKc1","passwordRecovery":"_34FuWxN8","warning":"_3md59o4i"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/pages/RecoverPasswordPage/RecoverPasswordPage.styl
// module id = 356
// module chunks = 0